module.exports = __webpack_public_path__ + "components/country-flag/static/in-1434165acf97a8c1a31a1d7702d03ca5.svg";